import React from "react";
import {AndroidFilled, AppleFilled, AppstoreFilled, LinuxOutlined, WindowsFilled} from "@ant-design/icons";
import {isAndroid, isIOS, osName} from "react-device-detect";
import PlatformType from "../types/PlatformType";

export interface PlatformInfo {
    type: PlatformType
    code: string
    name: string
    icon: React.ReactNode
}

export const PLATFORMS: PlatformInfo[] = [
    {type: PlatformType.ALL, code: "ALL", name: "All platforms", icon: <AppstoreFilled/>},
    {type: PlatformType.ANDROID, code: "AND", name: "Android", icon: <AndroidFilled/>},
    {type: PlatformType.WINDOWS, code: "WIN", name: "Windows", icon: <WindowsFilled/>},
    {type: PlatformType.MACOS, code: "MAC", name: "macOS", icon: <AppleFilled/>},
    {type: PlatformType.LINUX, code: "LNX", name: "Linux", icon: <LinuxOutlined/>},
];

export const BUILD_PLATFORMS = PLATFORMS.filter(p => p.type !== PlatformType.ALL);

export function platformInfo(type: PlatformType): PlatformInfo {
    return PLATFORMS.find(p => p.type === type) ?? PLATFORMS[0];
}

export function devicePlatform(): PlatformType | undefined {
    if (isAndroid) return PlatformType.ANDROID;
    if (isIOS) return undefined;
    const name = (osName || "").toLowerCase();
    if (name.startsWith("windows")) return PlatformType.WINDOWS;
    if (name.includes("mac")) return PlatformType.MACOS;
    if (/linux|ubuntu|debian|fedora|mint|arch/.test(name)) return PlatformType.LINUX;
    return undefined;
}
